import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: 'Nouvelle commande {{method}} !',
        scheduled: 'Commande {{method}} planifiée !',
      },
      labels: {
        today: "aujourd'hui",
        time_remaining_to_accept: 'restant pour accepter',
      },
      time_tag: {
        asap: '🕓 Retrait dans {{time}}',
        scheduled: '🕓 Retrait {{day}} à {{time}}',
      },
      time_tag_estimated: {
        asap: '🕓 Estimation retrait : {{time}}',
        scheduled: '🕓 Estimation retrait : {{day}} à {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmer la commande',
        cancel_order: 'Annuler la commande',
      },
      feedback: {
        rough_estimate_warning:
          "Il s'agit d'une estimation approximative. Vous recevrez le temps de préparation réel une fois un livreur assigné et l'heure de livraison confirmée. À ce moment, votre ticket sera imprimé automatiquement.",
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Temps de préparation',
      labels: {
        today: "aujourd'hui",
        order_time: {
          delivery: {
            asap: 'Livraison dans',
            scheduled: 'Livraison le',
          },
          other: {
            asap: 'Retrait dans',
            scheduled: 'Retrait le',
          },
        },
        can_you_make_it: 'Pouvez-vous y arriver ?',
        we_also_send_this_update_to_the_customer: 'Nous envoyons aussi cette mise à jour au client',
      },
      buttons: {
        yes_lets_go: "Oui, c'est parti !",
        no_change_time: "Non, changer l'heure",
        confirm: 'Confirmer',
      },
      toasts: {
        order_confirmed: {
          title: 'Commande #{{number}} confirmée',
          body: 'Ne préparez pas encore ! Nous vous préviendrons quand un livreur est assigné.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          "Malheureusement, la livraison doit être annulée car le livreur n'est pas disponible. Cliquez sur les trois points en haut à droite pour annuler la commande et rembourser le client.",
        [BackendErrorCode.DeliveryProviderException]:
          "Malheureusement, la livraison doit être annulée car le livreur n'est pas disponible. Cliquez sur les trois points en haut à droite pour annuler la commande et rembourser le client.",
      },
    },
  },
};
